export default function getCartItemServiceLabel(item) {
	var serviceCode = -1;
	if (item.selectedProviderService) {
		serviceCode = item.selectedProviderService.serviceId;
	} 
	var service = {};
	switch (serviceCode) {
		case -1:
			service.iconClassName = 'fad fa-truck-loading';
			service.Label = `Service Error `;
			service.Name = '';
			service.formattedAddress = '';
			service.IsOutbound = false;
			service.IsInbound = false;
			break;
		case 0:
			service.iconClassName = 'fad fa-truck-loading';
			service.Label = `Shipping From:  ${item.shippingLocations[0].City}, ${item.shippingLocations[0].State} `;
			service.Name = '';
			service.formattedAddress = '';
			service.address = item.shippingLocations[0];
			service.IsOutbound = true;
			service.IsInbound = false;
			break;
		case 1:
			service.iconClassName = 'fad fa-car-mechanic';
			service.Label = 'Installation';
			service.Name = null;
			service.formattedAddress = `${String.fromCharCode(13)}${
				item.installLocations[0].Address1
			}${String.fromCharCode(13)}${item.installLocations[0].City} , ${item.installLocations[0].State} ${
				item.installLocations[0].ZipPostalCode
			} `;
			service.address = item.installLocations[0];
			service.IsOutbound = false;
			service.IsInbound = true;
			service.IsDelivery = false;
			break;
		case 2:
			service.iconClassName = 'fad fa-shipping-timed';
			service.Label = 'Delivery Only';
			service.Name = item.deliveryOnlyLocations[0].Name;
			service.formattedAddress = '';
			service.address = item.deliveryOnlyLocations[0];
			service.IsOutbound = false;
			service.IsInbound = false;
			service.IsDelivery = true;
			break;
		case 3:
			service.iconClassName = 'fad fa-tools';
			service.Label = 'Delivery with Installation';
			service.Name = item.deliveryLocations[0].Name;
			service.formattedAddress = '';
			service.address = item.deliveryLocations[0];
			service.IsOutbound = false;
			service.IsInbound = false;
			service.IsDelivery = true;
			break;
		case 4:
			service.iconClassName = 'far fa-ambulance';
			service.Label = 'Roadside Assistance';
			service.Name = item.roadsideLocations[0].Name;
			service.formattedAddress = '';
			service.address = item.roadsideLocations[0];
			service.IsOutbound = false;
			service.IsInbound = false;
			service.IsDelivery = true;
			break;
		case 5:
			service.iconClassName = 'fad fa-phone';
			service.Label = 'Call Only';
			service.formattedAddress = '';
			service.IsDelivery = false;
			break;
		case 6:
			service.iconClassName = 'fad fa-hand-holding-box';
			service.Label = 'Pickup at';
			service.Name = item.pickupLocations[0].Name;
			service.formattedAddress = ` ${String.fromCharCode(13)}${
				item.pickupLocations[0].Address1
			}${String.fromCharCode(13)}${item.pickupLocations[0].City} , ${item.pickupLocations[0].State} ${
				item.pickupLocations[0].ZipPostalCode
			} `;
			service.address = item.pickupLocations[0];
			service.IsOutbound = false;
			service.IsInbound = true;
			service.IsDelivery = false;
			break;
		case 7:
			service.iconClassName = 'fad fa-tools';
			service.Label = 'Repair at';
			service.Name = item.repairLocations[0].Name;
			service.formattedAddress = `${String.fromCharCode(13)}${
				item.repairLocations[0].Address1
			}${String.fromCharCode(13)}${item.repairLocations[0].City} , ${item.repairLocations[0].State} ${
				item.repairLocations[0].ZipPostalCode
			} `;
			service.address = item.repairLocations[0];
			service.IsOutbound = false; // Mobile Guys Can Be Swapped in and need Pickup Address
			service.IsInbound = true;
			service.IsDelivery = false;
			break;
		case 8: 
			service.iconClassName = 'fad fa-tools';
			service.Label = 'Mobile Delivery and Repair';
			service.Name = item.mobileRepairLocations[0].Name; 
			service.formattedAddress = '';
			service.address = item.mobileRepairLocations[0];
			service.IsOutbound = false;
			service.IsInbound = false;
			service.IsDelivery = true;
			break;
		case 10:
			service.iconClassName = 'fad fa-link';
			service.Label = 'Affiliate Link';
			service.Name = item.affiliateLocations[0].Name;
			service.formattedAddress = `${String.fromCharCode(13)}${
				item.affiliateLocations[0].Address1
			}${String.fromCharCode(13)}${item.affiliateLocations[0].City} , ${item.affiliateLocations[0].State} ${
				item.affiliateLocations[0].ZipPostalCode
			} `;
			service.address = item.repairLocations[0];
			service.IsOutbound = false; // Mobile Guys Can Be Swapped in and need Pickup Address
			service.IsInbound = false;
			service.IsDelivery = item.repairLocations[0].IsMobile;
			break;
	}
	return service;
}
